import { siteData } from '@/mocks/siteData';

export default function FeaturesSection() {
  return (
    <section id="features" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <div className="inline-flex items-center gap-2 px-3 py-1 bg-secondary-100 text-secondary-700 rounded-full text-xs font-label mb-3">
            <i className="ri-star-line"></i>平台优势
          </div>
          <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950 mb-3">
            为什么几百万人选择黑料
          </h2>
          <p className="text-sm text-foreground-500 max-w-[500px] mx-auto">
            四大核心优势，重新定义吃瓜体验
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {siteData.features.map((feature) => (
            <div
              key={feature.id}
              className="group bg-background-50 border border-background-200/70 rounded-2xl p-6 md:p-7 hover:border-primary-300 hover:bg-primary-50/30 transition-all duration-300"
            >
              <div className="w-12 h-12 flex items-center justify-center rounded-xl bg-accent-100 text-accent-600 mb-5 group-hover:bg-accent-200 transition-colors">
                <i className={`${feature.icon} text-xl`}></i>
              </div>

              <h3 className="font-heading text-lg font-semibold text-foreground-900 mb-3">
                {feature.title}
              </h3>
              <p className="text-sm text-foreground-600 leading-relaxed">
                {feature.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}